import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";


  const ActivityList = async (activity_ids?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master_activities/list?sort=sort&order=asc&status=active&activity_ids=${activity_ids}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const EditById = async (id : string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/workflow/details?workflow_id=${id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const WorkflowList = async (page: number , pageSize: number, sort?: string, order?: string, activityTypeId?:string, keyword?: string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/workflow/list?page=${page}&size=${pageSize}&sort=${sort}&status=active,inactive,draft,published&order=${order}&master_activity_id=${activityTypeId}&keyword=${keyword}&id=`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const WorkflowListDrop = async (id:any) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/workflow/list?sort=id&status=active&publish_status=published&order=desc&id=&master_activity_id=${id}`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const ProcessList = async (process_id : string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master_process/get_process_by_activity?master_activity_id=${process_id}&status=active,inactive`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }; 

  const registerWorkflow = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/workflow/save_workflow_definition`, 
       dataToSend,
       {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };

  const saveWorkFlowDetails = async (dataToSend:any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/workflow/save_workflow_details`, dataToSend ,{
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  };


  const listAllPlateTypes =  async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_plate_types?status=active` ,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listEquipmentFilter = async (type_id:string) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/equipments/list_all?sort=&order=desc&status=active&keyword=&process_id=${type_id}&id`,
      {
        headers: {
          'x-auth-token': authToken,
          'x-userid': authUserID
        }
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const changeWorkflowStatus = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/workflow/change_status`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const PublishWorkflow = async (dataToSend : any) => {
    try {
      const response = await axiosInstance.post(`${baseUrl}/workflow/publish_status`, 
       dataToSend,
       {
         headers: {
           'x-auth-token': authToken,
           'x-userid': authUserID
         }
       }
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


  const workflow = {
    ActivityList,
    WorkflowList,
    ProcessList,
    registerWorkflow,
    saveWorkFlowDetails,
    EditById,
    listEquipmentFilter,
    listAllPlateTypes,
    changeWorkflowStatus,
    PublishWorkflow,
    WorkflowListDrop
  };
  
  export { workflow };